<div class="overlay" (click)="cerrar.emit()">
  <div class="modal scroll-oscuro" (click)="$event.stopPropagation()">
    <div class="cabecera">
      <h2>Nuevo registro</h2>
      <button type="button" class="cerrar" (click)="cerrar.emit()" aria-label="Cerrar">✕</button>
    </div>

    <div class="tabs">
      <button type="button" [class.activo]="modo() === 'nuevo-proveedor'" (click)="cambiarModo('nuevo-proveedor')">
        Proveedor nuevo + producto
      </button>
      <button type="button" [class.activo]="modo() === 'producto-existente'" (click)="cambiarModo('producto-existente')">
        Producto en proveedor existente
      </button>
    </div>

    @if (modo() === 'nuevo-proveedor') {
      <section class="bloque bloque--proveedor">
        <h3>Datos del proveedor</h3>
        <div class="grid">
          <label>
            Letra
            <select [ngModel]="letra()" (ngModelChange)="letra.set($event)">
              @for (l of letras; track l) {
                <option [value]="l">{{ l }}</option>
              }
            </select>
          </label>
          <label class="col-2">
            Nombre *
            <input [ngModel]="nombreProveedor()" (ngModelChange)="nombreProveedor.set($event)" placeholder="Ej. Nombre comercial del proveedor" />
          </label>
          <label>
            Contacto
            <input [ngModel]="contacto()" (ngModelChange)="contacto.set($event)" placeholder="Ej. Encargado de ventas" />
          </label>
          <label>
            Teléfono
            <input [ngModel]="telefono()" (ngModelChange)="telefono.set($event)" placeholder="Ej. +57 300 123 4567" />
          </label>
          <label class="col-2">
            Tarjeta del proveedor
            <div class="input-archivo">
              <input type="file" accept="image/*" (change)="alElegirTarjeta($event)" id="archivo-tarjeta" />
              <label for="archivo-tarjeta" class="input-archivo-boton">Elegir foto</label>
              @if (tarjetaPreviewUrl(); as prev) {
                <button type="button" class="miniatura-preview" (click)="ampliar(prev, 'Tarjeta del proveedor')">
                  <img [src]="prev" alt="Vista previa tarjeta del proveedor" />
                </button>
              } @else {
                <span class="input-archivo-nombre">Ningún archivo elegido</span>
              }
            </div>
          </label>
        </div>
      </section>
    } @else {
      <section class="bloque bloque--proveedor">
        <h3>Proveedor existente</h3>
        <label>
          Buscar proveedor *
          <div class="buscador-proveedor">
            <span class="buscador-icono">🔍</span>
            <input
              [ngModel]="busquedaProveedor()"
              (ngModelChange)="busquedaProveedor.set($event)"
              placeholder="Ej. Lucky"
            />
          </div>
        </label>
        <div class="lista-proveedores">
          @for (p of proveedoresFiltrados(); track p.codigo) {
            <button
              type="button"
              class="fila-proveedor"
              [class.activo]="proveedorExistenteCodigo() === p.codigo"
              (click)="proveedorExistenteCodigo.set(p.codigo)"
            >
              {{ p.codigo }} · {{ p.nombre || 'Sin nombre' }}
            </button>
          } @empty {
            <p class="sin-resultados">Ningún proveedor coincide con la búsqueda.</p>
          }
        </div>
      </section>
    }

    <section class="bloque bloque--producto">
      <h3>Producto — mueble</h3>
      <label>
        Mueble (opcional)
        <input [ngModel]="mueble()" (ngModelChange)="mueble.set($event)" placeholder="Ej. Sofá modular 3 puestos" />
      </label>
    </section>

    <section class="bloque bloque--fotos">
      <h3>Fotos del producto</h3>
      <div class="input-archivo">
        <input type="file" accept="image/*" (change)="agregarFoto($event)" id="archivo-foto-nueva" />
        <label for="archivo-foto-nueva" class="input-archivo-boton">Agregar foto</label>
      </div>
      @for (f of fotos(); track f.claveLocal) {
        <div class="fila-lista">
          <button type="button" class="miniatura-preview" (click)="ampliar(f.previewUrl, f.etiqueta || 'Foto del producto')">
            <img [src]="f.previewUrl" alt="" />
          </button>
          <input
            class="etiqueta"
            [ngModel]="f.etiqueta"
            (ngModelChange)="actualizarEtiquetaFoto(f.claveLocal, $event)"
            placeholder="Ej. Vista general"
          />
          <button type="button" class="quitar-x" (click)="quitarFoto(f.claveLocal)" aria-label="Quitar foto">✕</button>
        </div>
      }
    </section>

    <section class="bloque bloque--telas">
      <h3>Fichas de tela</h3>
      <button type="button" class="boton-secundario" (click)="agregarTela()">+ Agregar tela</button>
      @for (t of telas(); track t.claveLocal) {
        <div class="tarjeta-tela">
          <div class="grid">
            <label>
              Foto frente
              <div class="input-archivo">
                <input type="file" accept="image/*" (change)="alElegirFrenteTela(t.claveLocal, $event)" [id]="'frente-' + t.claveLocal" />
                <label [for]="'frente-' + t.claveLocal" class="input-archivo-boton">Elegir foto</label>
                @if (t.frentePreviewUrl; as prev) {
                  <button type="button" class="miniatura-preview" (click)="ampliar(prev, 'Tela · Frente')">
                    <img [src]="prev" alt="Vista previa frente de tela" />
                  </button>
                }
              </div>
            </label>
            <label>
              Foto reverso
              <div class="input-archivo">
                <input type="file" accept="image/*" (change)="alElegirReversoTela(t.claveLocal, $event)" [id]="'reverso-' + t.claveLocal" />
                <label [for]="'reverso-' + t.claveLocal" class="input-archivo-boton">Elegir foto</label>
                @if (t.reversoPreviewUrl; as prev) {
                  <button type="button" class="miniatura-preview" (click)="ampliar(prev, 'Tela · Reverso')">
                    <img [src]="prev" alt="Vista previa reverso de tela" />
                  </button>
                }
              </div>
            </label>
            <label>
              Colores
              <input [ngModel]="t.colores" (ngModelChange)="actualizarTela(t.claveLocal, { colores: $event })" placeholder="Ej. Azul petróleo" />
            </label>
            <label>
              Tipo
              <input [ngModel]="t.tipo" (ngModelChange)="actualizarTela(t.claveLocal, { tipo: $event })" [attr.list]="'tipos-tela'" placeholder="Ej. Velvet" />
            </label>
            <label class="col-2">
              ID muestrario
              <input [ngModel]="t.muestrario" (ngModelChange)="actualizarTela(t.claveLocal, { muestrario: $event })" placeholder="Ej. HT-2051" />
            </label>
          </div>
          <button type="button" class="quitar-tela" (click)="quitarTela(t.claveLocal)">Quitar esta tela</button>
        </div>
      }
      <datalist id="tipos-tela">
        @for (tipo of tiposSugeridos; track tipo) {
          <option [value]="tipo"></option>
        }
      </datalist>
    </section>

    <section class="bloque bloque--producto">
      <h3>Datos del producto</h3>
      <div class="grid">
        <label>
          Precio FOB (USD)
          <input [ngModel]="fob()" (ngModelChange)="fob.set($event)" inputmode="decimal" placeholder="Ej. 128.50" />
        </label>
        <label>
          MOQ
          <input [ngModel]="moq()" (ngModelChange)="moq.set($event)" placeholder="Ej. 50 sets" />
        </label>
        <label class="col-2">
          Unidades/contenedor
          <input [ngModel]="unidadesPorContenedor()" (ngModelChange)="unidadesPorContenedor.set($event)" inputmode="numeric" placeholder="Ej. 100" />
        </label>
      </div>
      <label class="campo-color-estructura">
        Color de estructura (opcional)
        <div class="fila-color-estructura">
          <input [ngModel]="colorEstructuraTexto()" (ngModelChange)="colorEstructuraTexto.set($event)" placeholder="Ej. Nogal oscuro" />
          <div class="input-archivo">
            <input type="file" accept="image/*" (change)="alElegirColorEstructura($event)" id="archivo-color-estructura" />
            <label for="archivo-color-estructura" class="input-archivo-boton">Elegir foto</label>
            @if (colorEstructuraPreviewUrl(); as prev) {
              <button type="button" class="miniatura-preview" (click)="ampliar(prev, 'Color de estructura')">
                <img [src]="prev" alt="Vista previa color de estructura" />
              </button>
            }
          </div>
        </div>
      </label>
      <label>
        Atributos especiales (separados por coma)
        <input [ngModel]="atributosTexto()" (ngModelChange)="atributosTexto.set($event)" placeholder="Ej. Luces LED, Motor, Sonido" />
      </label>
      <label>
        Notas
        <textarea [ngModel]="notas()" (ngModelChange)="notas.set($event)" placeholder="Ej. Medidas, material, observaciones…"></textarea>
      </label>
    </section>

    @if (error(); as msg) {
      <p class="mensaje-error">{{ msg }}</p>
    }

    <div class="pie">
      <button type="button" (click)="cerrar.emit()" [disabled]="guardando()">Cancelar</button>
      <button type="button" class="boton-primario" (click)="guardar()" [disabled]="!puedeGuardar || guardando()">
        {{ guardando() ? 'Guardando…' : 'Guardar' }}
      </button>
    </div>
  </div>

  @if (imagenAmpliada(); as img) {
    <div (click)="$event.stopPropagation()">
      <app-visor-imagen [url]="img.url" [titulo]="img.titulo" (cerrar)="cerrarAmpliada()" />
    </div>
  }
</div>
